import { login as loginInterface, getMenu } from "@/service/api/login.js";
import moment from "moment";
import ls from '@/utils/Ls';

import { encrypt, decrypt } from "@/utils/jsencrypt";
export default {
    data() {
        return {
            user_account: '',
            user_pwd: '',
            redirect: "",
            timer: null,
            countTime: "",
            pubk: "",
            is_showPassword: false,
            login_loading: false,
            icon: "mdi-eye-off",
            type: "password",
        }
    },
    async mounted() {
        this.overlay = true;
        try {
            if (this.$route.query.redirect) {
                this.redirect = this.$route.query.redirect;
            }
            this.getAccount();

            // 进入登录页面清除token等信息

            this.$store.dispatch("set_userData", {});
            this.$store.dispatch("set_token", { token: null });
            // this.$store.commit('set_sideMenu', [])
            this.$store.commit("set_topcompanylist", []);
            // 保存退出登录之前的语言
            const language = this.login_language;
            // ls.clear();
            // 保存退出登录之前的语言
            if (language) {
                ls.set("localeLanguage", language);
            }

            // sessionStorage.clear();
            this.$store.dispatch("resetState");

            try {
                this.pubk = await this.$store.dispatch("setPubk");
            } catch (err) {
                this.pubk = await this.$store.dispatch("setPubk");
            }

            await this.$store.dispatch("setCurrentCompanyLanguageList");
            await this.$store.dispatch("set_languageList", this.$store.state.lang);
            const langs = Object.keys(this.$store.state.languageList);
            const values = Object.values(this.$store.state.languageList);
            langs.forEach((item, index) => {
                if (item != "code" || item != "status" || item != "msg")
                    this.$i18n.mergeLocaleMessage(item, values[index]);
            });
            const currentCompanyLanguage = this.$store.state.currentCompanyLanguage;
            const is_default = currentCompanyLanguage.filter(
                (item) => item.value == this.login_language
            );
            const currentCompanyDefaultLanguage = currentCompanyLanguage.filter(
                (item) => item.is_default == 1
            );
            is_default.length > 0
                ? this.$store.commit("set_lang", {
                    text: "",
                    value: is_default[0].value,
                })
                : this.$store.commit("set_lang", {
                    text:
                        currentCompanyDefaultLanguage.length > 0
                            ? currentCompanyDefaultLanguage[0].text
                            : "",
                    value:
                        currentCompanyDefaultLanguage.length > 0
                            ? currentCompanyDefaultLanguage[0].value
                            : "",
                });
            this.overlay = false;
            // this.$store.commit('set_lang', {
            //   text: this.$store.state.currentCompanyLanguage[0].text,
            //   value: this.$store.state.currentCompanyLanguage[0].value,
            // })
        } catch (err) {
            this.overlay = false;
        }
    },
    methods: {
        getAccount() {
            const username = ls.get("user_account");
            const password = ls.get("mmdqwe");
            const rememberMe = ls.get("rememberMe");
            this.user_account = username ? username : this.user_account;
            this.user_pwd = password ? decrypt(password) : this.user_pwd;
            this.remember = rememberMe === undefined ? false : Boolean(rememberMe);
            // console.log(rememberMe)
        },
        showPassword() {
            this.is_showPassword = !this.is_showPassword;
            if (this.is_showPassword) {
                this.icon = "mdi-eye";
                this.type = "text";
            } else {
                this.icon = "mdi-eye-off";
                this.type = "password";
            }
        },
        forgetPassword() {
            let url = "";
            if (window.location.href.indexOf("?") > 0) {
                url = window.location.href.slice(0, window.location.href.indexOf("?"));
            } else {
                url = window.location.href;
            }

            this.$router.push({
                path: "/forget-password",
                query: {
                    login_url: url,
                },
            });
        },
        // 账号改变
        accountUpdate() {
            if (!document.onkeydown) {
                this.handlerEnter(true);
                this.countTime = null;
                clearInterval(this.timer);
                this.timer = null;
            }
        },
        // num传入的数字，n需要的字符长度
        PrefixInteger(num, n) {
            return (Array(n).join(0) + num).slice(-n);
        },
        countDown(endDate) {
            // const endDate = 1605845601262
            let m1 = new Date().valueOf();
            let m2 = moment(endDate).valueOf();
            var du = moment.duration(m2 - m1, "ms");
            var year = du.years();
            var month = du.months();
            var date = du.days();
            var hours = du.hours();
            var mins = du.minutes();
            var ss = du.seconds();
            if (
                year <= 0 &&
                month <= 0 &&
                date <= 0 &&
                hours <= 0 &&
                mins <= 0 &&
                ss <= 0
            ) {
                return;
            } else {
                return (
                    (year ? this.PrefixInteger(year, 2) + "-" : "") +
                    (month || year ? this.PrefixInteger(month, 2) + "-" : "") +
                    (month || year || date ? this.PrefixInteger(date, 2) : "") +
                    " " +
                    this.PrefixInteger(hours, 2) +
                    ":" +
                    this.PrefixInteger(mins, 2) +
                    ":" +
                    this.PrefixInteger(ss, 2)
                );
            }
        },
        async login() {
            clearInterval(this.timer);
            // this.$router.push({
            //   name: 'secondary_confirmation'
            // })
            // return
            const isSubmit = this.$refs.login_form.validate();
            if (!isSubmit) return;
            // this.$http.get('/mrc-base-server/menu.json')
            // 如果记住密码就保存在 cookie里面 七天过期时间
            // 去除所有字符空格
            let user_account = this.user_account.replace(/\s*/g, "");
            let user_pwd = this.user_pwd.replace(/\s*/g, "");
            if (this.remember) {
                ls.set("user_account", user_account);
                ls.set("mmdqwe", encrypt(user_pwd));
                ls.set("rememberMe", this.remember);
            } else {
                ls.remove("user_account");
                ls.remove("mmdqwe");
                ls.remove("rememberMe");
            }
            // console.log(this.$encrypt({ msg: '暗杀教室看的哈卡上打开将碍事的卡上的金卡撒回到家客户爱神的箭哈萨克好的卡上撒娇的哈数据库的和喀什啊数据库等哈数据库汇顶科技阿手机客户端家圣诞节快化设计客户就卡萨汇顶科技碍事嘉实多卡仕达加上爱好卡上金卡手机客户端就看加上加上框架', key: this.$store.getters.pubk }));
            // return
            this.login_loading = true;
            this.handlerEnter();
            try {
                const res = await loginInterface({
                    user_account: this.$encrypt({
                        msg: user_account,
                        // key: 123,
                        key: this.$store.getters.pubk,
                    }),
                    user_pwd: this.$encrypt({
                        msg: user_pwd,
                        key: this.$store.getters.pubk,
                    }),
                    timestamp: new Date().valueOf(),
                });
                // res.is_enable_auth = false
                if (res.code == 200) {
                    this.$store.dispatch("set_sys_upload_type");
                    this.$store.dispatch("set_userData", res.data.user);
                    this.$store.dispatch("set_token", { token: res.data.token });
                    ls.set("refresh-token", res.data["refresh-token"]);
                    this.$store.commit("set_lang", {
                        text: "",
                        value: res.data.language,
                    });
                    await this.$store.commit(
                        "set_currentCompany",
                        res.data.user.org_level_uuid
                    );
                    await this.$store.commit(
                        "set_currentCompanyClientUuid",
                        res.data.user.clientUuid
                    );
                    // 请求当前公司的语言种类
                    await this.$store.dispatch("setCurrentCompanyLanguageList");
                    // 这是请求回来的公司语言种类
                    const currentCompanyLanguage =
                        this.$store.state.currentCompanyLanguage;
                    const is_default = currentCompanyLanguage.filter(
                        (item) => item.value == this.login_language
                    );
                    const currentCompanyDefaultLanguage = currentCompanyLanguage.filter(
                        (item) => item.is_default == 1
                    );
                    // 登录页选择的语言在用户语言种类里面，那就用登录选择的语言，反之，使用用户默认的语言;
                    if (currentCompanyLanguage.length <= 0) {
                        this.$store.commit(
                            "newsTips",
                            this.$t("message_accountHasNotLanguage")
                        );
                        this.login_loading = false;
                        return;
                    }
                    is_default.length > 0
                        ? this.$store.commit("set_lang", {
                            text: is_default[0].text,
                            value: is_default[0].value,
                        })
                        : this.$store.commit("set_lang", {
                            text:
                                currentCompanyDefaultLanguage.length > 0
                                    ? currentCompanyDefaultLanguage[0].text
                                    : "",
                            value:
                                currentCompanyDefaultLanguage.length > 0
                                    ? currentCompanyDefaultLanguage[0].value
                                    : "",
                        });

                    // 所有语言label和message等信息  // 这个获取全部语言的接口 我暂时注释掉，因为在进入登录界面的时候就获取了这个数据，数据比较大，影响登录的速度，故注释掉
                    // await this.$store.dispatch("set_languageList", this.$store.state.lang)
                    // 将所有的label国际化注入到 i18n 中
                    const langs = Object.keys(this.$store.state.languageList);
                    const values = Object.values(this.$store.state.languageList);
                    langs.forEach((item, index) => {
                        if (item != "code" || item != "status" || item != "msg")
                            this.$i18n.mergeLocaleMessage(item, values[index]);
                    });
                    /***userType 人员角色类型：0=普通人员 1超级管理员 2.普通管理员 3.隐藏管理员 4.系统管理员 5普通人员、单位管理员 */

                    // 登录的时候就获取 头部的公司下拉 单位管理员和员工有这个
                    if (
                        this.$store.state.userData.userType == "2" ||
                        this.$store.state.userData.userType == "3"
                    ) {
                        await this.$store.dispatch("set_topcompanylist");
                    }

                    this.$store.commit("set_loginStatus", true);

                    // 进入第一个页面的时候加载第一个页面功能的按钮权限
                    // const btnlist = await btnPermissionList({
                    //   function_uuid: this.$store.state.menuFunctionUuid,
                    // })
                    // this.$store.commit(
                    //   'setBtnPermission',
                    //   btnlist.data ? btnlist.data : []
                    // )
                    if (res.data.is_enable_auth === false) {
                        const menus_tree = await getMenu({
                            product_shortcode: "MMS",
                        });
                        // 设置菜单权限
                        this.$store.commit("setCurrentCopmpanyMenu", menus_tree.data);
                        this.$store.dispatch("set_languageList", this.$store.state.lang);
                        this.getLanguageAndUrl(this.$store.state.currentCopmpanyMenu);
                        if (menus_tree.data.length <= 0) {
                            this.$Message({
                                text: this.$t("message_noMenuList"),
                                color: "rgba(0,0,0,0.78)",
                            });
                            this.login_loading = false;
                            return;
                        }
                        this.$router.push({
                            path: "/dashboard",
                        });
                    } else {
                        this.$router.push({
                            name: "secondary_confirmation",
                            query: {
                                ua: res.data.user.user_account,
                            },
                        });
                    }
                }
                this.login_loading = false;

                if (res.locked_expire_time) {
                    // 解除登录界面的enter事件
                    this.handlerEnter();
                    clearInterval(this.timer);
                    this.countTime = this.countDown(res.locked_expire_time);
                    // console.log(this.countDown(res.locked_expire_time), "剩余时间");
                    this.timer = setInterval(() => {
                        this.countTime = this.countDown(res.locked_expire_time);
                    }, 1000);
                }

                if (res.code == "01075") {
                    const pubk = await this.$store.dispatch("setPubk");

                    if (pubk == this.pubk) {
                        this.login_loading = false;
                        return;
                    }
                    await this.login();
                }
            } catch (err) {
                console.log(err);
                this.handlerEnter(true);
                this.login_loading = false;
            }

            // this.login_loading = false
        },
        getLanguageAndUrl(arr) {
            arr.forEach((item) => {
                if (item.menus_tree && item.menus_tree.length > 0) {
                    this.getLanguageAndUrl(item.menus_tree);
                } else {
                    this.$store.commit("setAllMenuUrlList", {
                        url: item.url,
                        // title: item.language_name
                        title: item.menu_name,
                        function_uuid: item.function_uuid,
                    });
                }
            });
        },
    },
}